import React, { Component } from 'react'
import { connect } from 'react-redux'
import {togglePakketVisibile, deletePakket} from '../../../redux/actions/productActions'
import {showPakketModal, showMessageModal} from '../../../redux/actions/miscActions'
import { single, multiple } from '../../../utils/Eenheden'
import { Switch, Popconfirm, Table, Space } from 'antd';


export class PakketOverview extends Component {
  
  handleDelete=(id)=>{
    this.props.deletePakket(id)
  }

  handleEdit=(product)=>{
    this.props.showPakketModal(product)
  }

  toggleIsActive=(e, id, naam)=>{
    const { pakketten } = this.props;
    if( e === true && pakketten.filter(x => x.isVisible === true).length >= 30){
      const feedback = {
        type: "warning",
        txt: "U heeft uw limiet van zichtbare pakketten bereikt.",
      };
      this.props.showMessageModal(feedback);
    } else {
      this.props.togglePakketVisibile(id, e, naam)
    }

  }



  render() {
    const { pakketten } = this.props;

    const columns = [
      {
        title: '#',
        dataIndex: 'volgNum',
        key: 'volgNum',
      },
      {
        title: "Foto",
        dataIndex: "productImage",
        key: "productImage",
        width: 80,
        render: (productImage) => (
          <img src={productImage} alt="" className="table-image" />
        ),
      },
      {
        title: 'Naam',
        dataIndex: 'pakketNaam',
        key: 'pakketNaam',
      },
      {
        title: "Prijs",
        dataIndex: "pakketPrijs",
        key: "pakketPrijs",
        render: (text, record) => `${new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'SRD'}).format(`${(record.pakketPrijs)}`)}`,
      },
      {
        title: "Type",
        dataIndex: "typePakket",
        key: "typePakket",
      },
      {
        title: "Zichtbaar",
        dataIndex: "isVisible",
        key: "isVisible",
        render: (text, record) => <Switch checked={record.isVisible} 
        checkedChildren={<i className="fas fa-check"></i>}
        unCheckedChildren={<i className="far fa-eye-slash"></i>}
        onChange={(e)=>this.toggleIsActive(e, record.id, record.pakketNaam)}
      />
      },
      {
        title: 'Acties',
        key: 'acties',
        render: (text, record) => (
        <Space size="middle">
          <p onClick={()=>this.handleEdit(record)}>Aanpassen</p> <Popconfirm title='Pakket verwijderen?' onConfirm={()=>this.handleDelete(record.id)}>
        <p>Verwijderen</p>
        </Popconfirm>
        </Space>
        )
      }
    ]

    return (
      <div className="pakket-weergaven">
        {/* {pakkettenList} */}
        <Table 
          columns={columns}
          dataSource={pakketten.sort((a,b)=>
            a.volgNum - b.volgNum 
            )}
          expandable={{
            expandedRowRender: record => <ul>
              {record.producten.map(y => { return(
             <li key={y.productNaam}>
               {y.aantalNum} x {y.aantalNum > 1 ? multiple[y.productEenheid] : single[y.productEenheid]} {y.productNaam}
             </li>
           )})}
            </ul>
          }}
        />

      </div>
    )
  }
}

export default connect(null, {togglePakketVisibile, deletePakket, showPakketModal, showMessageModal})(PakketOverview)
